import React from "react";
import { Box, MenuItem, Typography, Select } from "@mui/material";
import { getIn, useField } from "formik";

export default function PremiumSelect({
  label,
  name,
  options = [],
  placeholder = "انتخاب کنید...",
  disabled = false,
  isRequired = false,
  formik,
}) {
  const value = getIn(formik.values, name) ?? "";
  const errorText = getIn(formik.errors, name);
  const touched = getIn(formik.touched, name);
  const isError = touched && Boolean(errorText);
  // Map options above the main return
  const renderedOptions = options?.map((opt, index) => (
    <MenuItem disabled={disabled} key={index} value={opt?.value}>
      {opt?.label}
    </MenuItem>
  ));

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        sx={{
          color: isError ? "#ff1744" : "rgba(255,255,255,0.8)",
          fontSize: 14,
          fontWeight: 700,
          mb: 1,
          lineHeight: 1.6,
          transition: "color 0.3s ease",
        }}
      >
        {label}
        {isRequired && (
          <Typography component="span" sx={{ color: "#ff1744", mr: 0.5 }}>
            *
          </Typography>
        )}
      </Typography>

      <Select
        value={value}
        name={name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        displayEmpty
        disabled={disabled}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: "#1a1a1a",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "12px",
              mt: 1,
              "& .MuiMenuItem-root": {
                color: "#fff",
                fontFamily: "inherit",
                fontSize: 14,
                py: 1.5,
                "&:hover": {
                  bgcolor: "rgba(0, 255, 204, 0.1)",
                },
                "&.Mui-selected": {
                  bgcolor: "rgba(0, 255, 204, 0.2)",
                  "&:hover": {
                    bgcolor: "rgba(0, 255, 204, 0.3)",
                  },
                },
              },
            },
          },
        }}
        sx={{
          width: "100%",
          bgcolor: "rgba(10, 10, 10, 0.6)",
          border: "1px solid",
          borderColor: isError ? "#ff1744" : "rgba(255, 255, 255, 0.1)",
          borderRadius: "12px",
          color: value === "" ? "rgba(255, 255, 255, 0.3)" : "#fff",
          fontSize: 15,
          fontFamily: "inherit",
          transition: "all 0.3s ease",
          boxSizing: "border-box",
          cursor: "pointer",

          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },

          "& .MuiSelect-select": {
            py: 1.6,
            px: 2,
          },

          "& .MuiSvgIcon-root": {
            color: "rgba(255, 255, 255, 0.5)",
          },

          "&:hover": {
            borderColor: isError ? "#ff1744" : "rgba(255, 255, 255, 0.2)",
            bgcolor: "rgba(15, 15, 15, 0.8)",
          },
          "&.Mui-focused": {
            bgcolor: "rgba(0, 0, 0, 0.8)",
            borderColor: isError ? "#ff1744" : "#00ffcc",
            boxShadow: isError
              ? "0 0 0 4px rgba(255, 23, 68, 0.1)"
              : "0 0 0 4px rgba(0, 255, 204, 0.1)",
          },
        }}
      >
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>

        {renderedOptions}
      </Select>

      {isError && (
        <Typography
          sx={{ color: "#ff1744", fontSize: 13, mt: 1, fontWeight: 500 }}
        >
          {errorText}
        </Typography>
      )}
    </Box>
  );
}
